import React from 'react'
import { Button } from '../../../components/ui/button'
import { Spinner } from '../../../components/ui/spinner'
import { SellerCard } from '../../Vendedores/components/SellerCard'
import { useTeamsMembersPageController } from './useTeamsMembersPageController'
import { EmptyMemberTable } from '../../../components/EmptyMemberList'

export const TeamsMembersPage = () => {
  const {
    data,
    handleSellerDetailsPage,
    hasNextPage,
    isFetching,
    isFetchingNextPage,
    ref,
  } = useTeamsMembersPageController()

  const hasMembers = data && data.pages.some((page) => page.users.length > 0)

  return (
    <div className="w-full">
      <div
        style={{
          display: 'grid',
          ...(hasMembers && {
            gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))',
          }),
          gap: '16px',
        }}
      >
        {hasMembers ? (
          <>
            {data.pages.map((page, index) => (
              <React.Fragment key={index}>
                {page.users.map((seller) => (
                  <SellerCard
                    key={seller._id}
                    _id={seller._id}
                    name={seller.name}
                    profileImageUrl={seller.profileImageUrl}
                    team={seller?.team}
                    transactions={seller.transactions}
                    handleSellerDetailsPage={handleSellerDetailsPage}
                    isActive={seller.isActive}
                    isRemove
                  />
                ))}
              </React.Fragment>
            ))}
          </>
        ) : (
          <EmptyMemberTable />
        )}
      </div>

      <div className="mt-2 flex items-center justify-center" ref={ref}>
        <Button variant="ghost" disabled={!hasNextPage || isFetchingNextPage}>
          {isFetchingNextPage ? <Spinner /> : null}
        </Button>
      </div>
      <div>
        {isFetching && !isFetchingNextPage ? (
          <div className="flex items-center justify-center">
            <Spinner />
          </div>
        ) : null}
      </div>
    </div>
  )
}
